/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface MatchedStatementAnswer
 */
export interface MatchedStatementAnswer {
    /**
     * 
     * @type {number}
     * @memberof MatchedStatementAnswer
     */
    utteranceId?: number;
    /**
     * 
     * @type {string}
     * @memberof MatchedStatementAnswer
     */
    answerText?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchedStatementAnswer
     */
    customerAnswer?: string;
}

/**
 * Check if a given object implements the MatchedStatementAnswer interface.
 */
export function instanceOfMatchedStatementAnswer(value: object): boolean {
    return true;
}

export function MatchedStatementAnswerFromJSON(json: any): MatchedStatementAnswer {
    return MatchedStatementAnswerFromJSONTyped(json, false);
}

export function MatchedStatementAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchedStatementAnswer {
    if (json == null) {
        return json;
    }
    return {
        
        'utteranceId': json['utteranceId'] == null ? undefined : json['utteranceId'],
        'answerText': json['answerText'] == null ? undefined : json['answerText'],
        'customerAnswer': json['customerAnswer'] == null ? undefined : json['customerAnswer'],
    };
}

export function MatchedStatementAnswerToJSON(value?: MatchedStatementAnswer | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'utteranceId': value['utteranceId'],
        'answerText': value['answerText'],
        'customerAnswer': value['customerAnswer'],
    };
}

